import styles from "./series.module.css"

export const Future = ({theme})=>{
  
    return (
        <div  id={theme ?styles.day : styles.night} className={styles.currentMain}>
            <div>
               <h3 id={theme ?styles.day : styles.night} className={styles.h3}>INTERNATIONAL TOURS</h3>
                 <div className={styles.International}>
                     <p>India tour of England, Jul 2022</p>
                     <p>India tour of West Indies, Jul 2022</p>
                     <p>IRE Tri-Nation Women's T20I, Jul 2022</p>
                     <p>New Zealand tour of Ireland, Jul 2022</p>
                     <p>New Zealand tour of Scotland, Jul 2022</p>
                     <p>New Zealand tour of Netherlands, Aug 2022</p>
                     <p>New Zealand tour of West Indies, Aug 2022</p>
                     <p>Pakistan of Netherlands, Aug 2022</p>
                     <p>South Africa tour of England, Jul 2022</p>
                     <p>South Africa Women tour of England, Jul 2022</p>
                     <p>Afghanistan tour of Ireland, Aug 2022</p>
                     <p>Ireland v South Africa T20I Series, Aug 2022</p>
                     <p>Sri Lanka Under-19s tour of England, Aug 2022</p>
                     <p>Zimbabwe tour of Australia, Aug 2022</p>
                     <p>India Women tour of England, Sep 2022</p>
                     <p>New Zealand tour of Australia, Sep 2022</p>
                     <p>West Indies tour of Australia, Oct 2022</p>
                     <p>England tour of Australia, Oct 2022</p>
                     <p>South Africa tour of Australia, Dec 2022</p>
              </div>

              <h3 id={theme ?styles.day : styles.night} className={styles.h3}>INTERNATIONAL TOURNAMENTS</h3>
                 <div className={styles.International}>
                      <p>ICC Men's T20 World Cup</p>
                 </div>
            </div>
           
        </div>
    )
}
